<template>
  <div class="table-borderless">
    <v-simple-table dense>
      <tbody>
        <TitleRow>
          <span v-t="'Cost of changes'" />
        </TitleRow>
        <tr>
          <td><span v-t="'Price excl. tax'" /></td>
          <td class="text-right">{{ extrasPrice }} €</td>
        </tr>
        <tr>
          <td><span v-t="'VAT (20%)'" /></td>
          <td class="text-right">
            <span>{{ tax }} €</span>
          </td>
        </tr>
        <tr>
          <td><strong v-t="'Final price'" /></td>
          <td class="text-right">
            <strong>{{ finalPrice }} €</strong>
          </td>
        </tr>
      </tbody>
    </v-simple-table>
    <div class="mx-4 my-2">
      <small>
        <div
          class="mb-2"
          v-for="(note, i) in $store.state.pricing.notes"
          :key="'note-' + i"
          v-html="note"
        ></div>
      </small>
    </div>
  </div>
</template>

<script>
import TitleRow from "./TitleRow";
export default {
  components: {
    TitleRow,
  },

  computed: {
    extrasPrice() {
      return this.$store.state.pricing.extras_price;
    },
    tax() {
      return this.$store.state.pricing.tax;
    },
    finalPrice() {
      return this.$store.state.pricing.final_price;
    },
  },
};
</script>
